import { hslToHex } from '../util'
import '../styles/flamegraph-legend.css'

export function FlamegraphLegend({ data }) {
  return (
    <div class={'legend'}>
      {data && Object.keys(data).length > 1
        ? Object.entries(data).map(([label, color], i) => (
            <FlamegraphItem key={i} color={color} label={label} />
          ))
        : null}
    </div>
  )
}

function FlamegraphItem({ color, label }) {
  return (
    <span class={'legend-entry'}>
      <span class={'legend-swatch'} style={{ background: hslToHex(color, 100, 50) }} />
      <span>{label}</span>
    </span>
  )
}



// WEBPACK FOOTER //
// ./components/flamegraph-legend.js